<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :items="items" 
            :fields="fields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarItem">
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" 
              prev-text="Prev" next-text="Next" 
              hide-goto-end-buttons/>
          </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'Usuarios',
  props: {
    asignaPresupuestos: {
      type: Boolean,
      default: false
    },
    asignaTareasBrief: {
      type: Boolean,
      default: false
    },
    coordinador: {
      type: Boolean,
      default: false
    },
    abrirCaja: {
      type: Boolean,
      default: false
    },
    incluirInactivos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      title: 'Usuarios',
      items: [],
      fields: [
        {
          key: 'username',
          label: 'Usuario',
          sortable: true
        },
        {
          key: 'nombreCompleto',
          sortable: true
        },
        {
          key: 'usuarioRol',
          label: 'Rol',
          sortable: true
        },
      ],

      loaded: false,
      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      if (this.asignaPresupuestos || this.asignaTareasBrief || this.coordinador || this.abrirCaja ) {
        this.fields = [
          {
            key: 'username',
            label: 'Usuario',
            sortable: true
          },
          {
            key: 'nombreCompleto',
            sortable: true
          },
          {
            key: 'usuarioRol',
            label: 'Rol',
            sortable: true
          },
        ]
        
        let dispatch = 'usuarios/getUsuariosAsignar';
        if (this.asignaTareasBrief) {
          dispatch = 'usuarios/getUsuariosAsignarBrief';
        }
        if (this.coordinador) {
          dispatch = 'usuarios/getUsuariosCoordinadores';
        }
        if (this.abrirCaja) {
          dispatch = 'usuarios/getUsuariosAbrirCaja';
        }

        this.$store.dispatch(dispatch)
          .then(() => {
            this.items = this.$store.getters['usuarios/list'];
            this.totalRegistros = this.items.length;
          })
      } else {
        this.fields = [
          {
            key: 'nombre',
            sortable: true
          }
        ]
        let params = {
          incluirInactivos: this.incluirInactivos
        }
        this.$store.dispatch('usuarios/getList', params)
          .then(() => {
            this.items = this.$store.getters['usuarios/list'];
            this.totalRegistros = this.items.length;
          })
      }
    },
    seleccionarItem (item) {
      this.$emit('itemSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
</style>
